import { render, staticRenderFns } from "./PartsOrdering.vue?vue&type=template&id=8f85d8a0"
import script from "./PartsOrdering.vue?vue&type=script&lang=js"
export * from "./PartsOrdering.vue?vue&type=script&lang=js"
import style0 from "./PartsOrdering.vue?vue&type=style&index=0&id=8f85d8a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports